import { render } from "./СoursesСontainer.vue?vue&type=template&id=50cc73f0&scoped=true"
import script from "./СoursesСontainer.vue?vue&type=script&lang=js"
export * from "./СoursesСontainer.vue?vue&type=script&lang=js"

import "./СoursesСontainer.vue?vue&type=style&index=0&id=50cc73f0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50cc73f0"]])

export default __exports__